import React from "react";
import "../App.css";
import ContraLogo from "../Graphics/contraline_logo.png";
import RaisedButton from "material-ui/RaisedButton";
import {
  TwitterButton,
  FacebookLikeButton,
  FacebookShareButton,
  FacebookMessengerButton,
  GoogleButton,
  GoogleHangoutButton,
  PinterestButton,
  WhatsAppButton
} from "react-social-buttons";

export default class ThankYou extends React.Component {
  isBrowser() {
    return !(typeof document === "undefined" || typeof window === "undefined");
  }

  render() {
    let url = "";
    if (this.isBrowser()) {
      url = window.location.href;
    }

    return (
      <div className="panel">
        <div className="panel-header">
          <h2 style={{
            marginTop: 0,
            marginBottom: 0,
            fontSize: 18,
            color: "inherit",
            letterSpacing: 0,
            fontWeight: 500,







          }}> Thank you for expressing interest in Contraline. </h2>
        </div>
        <div className="panel-body">
          <p>You may close this window now.</p>
          <div id="buttons" style={{ marginTop: 30 }}>
            <div style={{ paddingBottom: 8 }}>
              <FacebookShareButton url={url} />
            </div>
            <TwitterButton url={url} text="Check Out Contraline!" />
          </div>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ThankYou.js